
import { Auth } from 'api/index'
import { CreateUserRequest } from 'api/punchlist/users/types'
import { useAppDispatch } from 'ducks/hooks'
import { FC, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { obHomeowner } from '../../../../assets'
import { configActions, userActions } from '../../../../ducks/actions'
import { getConfigValue, getNewEstimateValue, getUser } from '../../../../ducks/selectors'
import { UserType } from '../../../../ducks/user/types'
import { EMAIL_TYPE, USER_TYPE, history } from '../../../../helpers'
import { useIsXsScreen } from '../../../../hooks'
import { RegisterLoader } from '../../../templates'
import { Box, Grid, Stepper } from '../../../UI'
import { StepperProps } from '../../../UI/CustomUI/organisms/Stepper/types'
import HouseSvg from './../../../../assets/icons/custom/house.svg'
import { Company, Location, ProfessionalType } from './Steps'
import Role from './Steps/Role'
import useStyles from './styles'

const RegisterLogged: FC = () => {
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const replace = history.useReplace()
  const [registerLoading, setRegisterLoading] = useState(false)
  const userInfo = Auth.getUserInfo()
  const userEmailVerified = userInfo?.email_verified
  // const registerLoading = useSelector(getConfigValue('registrationLoading'))
  const registerImg = useSelector(getConfigValue('registerImg'))

  // const [registerImg, setRegisterImg] = useState(obInstitutionalClient)
  const user = useSelector(getUser)
  const [xsScreen] = useIsXsScreen()
  // const registerActiveStep = useSelector(getConfigValue('registerActiveStep')) || 0

  const [activeStep, setActiveStep] = useState(0)

  const bgColor = () => {
    let color = ''
    switch (user.clientType) {
      case USER_TYPE.HOMEOWNER:
        color = 'var(--head-text-color)'
        break
      case USER_TYPE.BROKER:
        color = 'var(--head-text-color)'
        break
      default:
        color = 'var(--head-text-color)'
        break
    }

    return color
  }

  const estimate = useSelector(getNewEstimateValue('estimate'))
  const redirectPath = useSelector(getConfigValue('redirectPath'))
  const contacts = estimate.properties?.contacts ? estimate.properties.contacts : []

  const steps: StepperProps['steps'] = [
    {
      content: <Role />,
      disableBack: true,
      nextText: 'Next',
      actionNext: () => {
        if (registerLoading) return
        setActiveStep(activeStep + 1)
      }
    },
  ]

  if (user.clientType === USER_TYPE.HOMEOWNER) {
    steps.push({
      content: <Location />,
      disableBack: true,
    })
  } else {
    const isInstitutional = user?.clientType === USER_TYPE.INSTITUTIONAL

    steps.push(
      {
        content: <ProfessionalType isInstitutional={isInstitutional} />,
        nextText: 'Next',
        actionNext: () => {
          if (registerLoading) return
          setActiveStep(activeStep + 1)
        }
      },
      {
        content: <Company />,
        nextText: 'Next',
        actionNext: () => {
          if (registerLoading) return
          setRegisterLoading(true)
          let request: CreateUserRequest = {
            companyName: user.companyName,
            phone: user.phone || parseInt(contacts[0]?.phone.replaceAll('-', '')),
            nar: user.nar || false,
            address: user.address,
            clientType: user.clientType,
            institutionalRole: user.institutionalRole,
            firstName: user.firstName,
            lastName: user.lastName,
            email: [{ emailType: EMAIL_TYPE.PRIMARY, email: user.emailString || '' }],
            affiliate: user?.affiliate || "",
          }
          if (userEmailVerified) {
            const requestNew: Partial<UserType> = {
              companyName: user.companyName,
              phone: user.phone || parseInt(contacts[0]?.phone.replaceAll('-', '')),
              nar: user.nar || false,
              address: user.address,
              clientType: user.clientType,
              institutionalRole: user.institutionalRole || null,
              firstName: user.firstName,
              lastName: user.lastName,
              registrationComplete: true,
              affiliate: user?.affiliate || "",
            }
            dispatch(userActions.updateUser(requestNew, (succ) => {
              if (succ) {
                dispatch(userActions.setUserValues({ attrs: { email: [{ emailType: EMAIL_TYPE.PRIMARY, email: user.emailString || '' }] } }))
                replace('/dashboard')
              }
              dispatch(configActions.setConfigValue({ type: 'registrationLoading', value: false }))
            }))
          } else {
            dispatch(userActions.newCreateUser(request, (succ) => {
              if (succ) {
                dispatch(userActions.setUserValues({ attrs: { email: [{ emailType: EMAIL_TYPE.PRIMARY, email: user.emailString || '' }] } }))
                replace('/register-success')
              }
              dispatch(configActions.setConfigValue({ type: 'registrationLoading', value: false }))
            }))
          }
        }
      }
    )
  }

  const updateNewUser = (attr: keyof UserType, value: any) => {
    dispatch(userActions.setUserValue({ attr, value }))
  }

  /*   const updateRegisterImg = (value: USER_TYPE) => {
      switch (value) {
        case USER_TYPE.BROKER:
          setRegisterImg(obAgent)
          break
        case USER_TYPE.HOMEOWNER:
          setRegisterImg(obHomeowner)
          break
        case USER_TYPE.INSTITUTIONAL:
          setRegisterImg(obInstitutionalClient)
          break
        default:
          break
      }
    } */

  // const fetchCurrentUser = useCallback(
  //   () => {
  //     dispatch(userActions.fetchCurrentUser(() => { }))
  //   }, [dispatch]
  // )

  // useEffect(() => {
  //   fetchCurrentUser()
  // }, [fetchCurrentUser])

  return (
    <RegisterLoader loading={registerLoading} icon={registerImg || obHomeowner}>
      <Grid className={classes.container} style={{ backgroundColor: !xsScreen ? bgColor() : 'white' }}>
        <img src={HouseSvg} alt="texture" className={classes.textureBottom} />
        <Grid item className={classes.center}>
          <Box className={classes.root}>
            <Box className={classes.content}>
              <Stepper
                withLogo
                steps={steps}
                activeStep={activeStep}
                setActiveStepAction={(step: number) => setActiveStep(step)}
                saveNewValueAction={(value: { attr: keyof UserType, value: any }) => updateNewUser(value.attr, value.value)}
                fixButtons
                showHeader={false}
                className={classes.stepper}
                center={false}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </RegisterLoader>
  )
}

export default RegisterLogged
